module.exports = __webpack_public_path__ + "img/59.76a88cd4.jpeg";